import { memo, useEffect, useState } from 'react';
import { Card, CardContent, Grid, Box, Button, IconButton, Chip, TextField, FormControl, Typography, MenuItem } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useTMutation } from '../../../../../utils/useTMutation';
import showToast from '../../../../../components/Hot-Toast/showToast';
import { useTQuery } from '../../../../../utils/useTQuery';
import { nextStep, previousStep, update } from '../../../../../slice/multiStepSlice';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

// Define schema for form validation
export const roleSchema = z.object({
    ROLE_IDS: z.array(z.string()).min(1, { message: "At least one role must be selected" }),
});

const MapSpecialtyToJobRole = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { values } = useSelector((state) => state?.multiStep)
    const [roles, setRoles] = useState([]);
    const [selectedRoles, setSelectedRoles] = useState([]);

    const { data: rolesData } = useTQuery(
        "jobs_roles",
        "/jobRoles",
        "post"
    );

    useEffect(() => {
        if (rolesData?.STATUS) {
            setRoles(rolesData.OUTPUT);
        }
    }, [rolesData]);
    useEffect(() => {
        if (values.ROLE_IDS) setSelectedRoles(values.ROLE_IDS);
    }, [values])
    const {
        control,
        handleSubmit,
        setValue,
        clearErrors,
        formState: { errors },
    } = useForm({
        resolver: zodResolver(roleSchema),
        defaultValues: { ROLE_IDS: values.ROLE_IDS || [] },
    });

    const { mutateAsync } = useTMutation("/addUpdateSpecialty", "post", (response) => {
        return response
    });

    const submitJobRole = async (formData) => {
        console.log("Job Data", formData)
        try {
            const response = await mutateAsync({
                ...formData,
                ID: values?.ID,
                SPECIALTY_STATUS: "Active"
            });
            console.log("sdjds", response)
            if (response.STATUS) {
                console.log("sRolea", formData?.ROLE_IDS)
                dispatch(update({ ROLE_IDS: formData?.ROLE_IDS }))
                showToast("success", response.MESSAGE, 3000);
                dispatch(nextStep())
                // navigate("/admin/profile-criteria/fetchSpecialtyRoleMappings")
            } else {
                showToast("error", response.MESSAGE, 3000);
            }

        } catch (error) {
            console.error("Add Request failed:", error);
            showToast("error", "Something went wrong, Please try again", 3000);
        }
    };

    const handleChipDelete = (roleId) => {
        setSelectedRoles((prev) => prev.filter(id => id !== roleId));
        setValue('ROLE_IDS', selectedRoles.filter(id => id !== roleId));
        clearErrors('ROLE_IDS');
    };

    const handleRoleChange = (event) => {
        const selectedRoleId = event.target.value;
        if (selectedRoleId && !selectedRoles.includes(selectedRoleId)) {
            const updatedRoles = [...selectedRoles, selectedRoleId];
            setSelectedRoles(updatedRoles);
            setValue('ROLE_IDS', updatedRoles);
        }
        errors.ROLE_IDS = false;
    };
    console.log("asdasd", roles, values)

    return (
        <>
                    {!values.REDIRECT && <Button
                                    onClick={() => dispatch(previousStep())}
                                    startIcon={<ArrowBackIosIcon sx={{ fontSize: "12px", color: "#000000" }} />}
                                    sx={{ textTransform: 'none', fontWeight: 500, fontSize: "14px", padding: 3, minWidth: 0 }}
                                >
                                </Button>}
            <Grid lg={12} >

                <CardContent>
                    <Typography variant="h2" component="div" mb={1} fontWeight="bold">
                        Assign to job roles
                    </Typography>
                    <form onSubmit={handleSubmit(submitJobRole)}>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                            <FormControl fullWidth margin="normal">
                                <Controller
                                    name="ROLE_IDS"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            select
                                            label="Select"
                                            value=""
                                            onChange={handleRoleChange}
                                            error={!!errors.ROLE_IDS}
                                            // helperText={errors.ROLE_IDS?.message}
                                            sx={{
                                                '& .MuiOutlinedInput-input': {
                                                    padding: 1.814
                                                },
                                            }}
                                        >
                                            <MenuItem disabled value="">Select</MenuItem>
                                            {roles.map((role) => (
                                                <MenuItem key={role.ID} value={role.ID}>
                                                    {role.ROLE_NAME}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )}
                                />
                                {errors.ROLE_IDS && <Typography color="error">{errors.ROLE_IDS.message}</Typography>}
                            </FormControl>

                            <Box sx={{ mt: 2 }}>
                                <Grid container spacing={1}>
                                    {selectedRoles.map((roleId) => (
                                        <Grid item xs={4} key={roleId}>
                                            <Chip
                                                label={roles.find(role => role.ID === roleId)?.ROLE_NAME}
                                                onDelete={() => handleChipDelete(roleId)}
                                                sx={{ borderRadius: 0.9 }}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button 
                                // variant="contained" sx={{ backgroundColor: '#6ebe44' }}
                                  className='gradientAdminThemeColor'
                                 type='submit'>
                                    Add
                                </Button>
                            </Box>
                        </Box>
                    </form>
                </CardContent>

            </Grid>

        </>
    );
};

export default memo(MapSpecialtyToJobRole);
